module.exports = __webpack_public_path__ + "static/media/viaggioOff.5e8d8c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SwimmySectionPress/images/viaggioOff.jpg
// module id = 2275
// module chunks = 0